import {nsMessages} from "../../../messages/fn";
import {TType} from "../../../messages/"
import {IMessage} from "../../../../index";
import {ObjectTypeId} from "../../../../constants";
import {global} from "../../../../appContext";
import messageflowHtml from './messageflow.html?raw';

export const template = messageflowHtml

export class viewModel {
    private readonly data: IMessage
    private readonly typeChecker: nsMessages.TypeChecker;
    private readonly isType: (...types: TType[]) => boolean;
    private readonly objectTypeId = ObjectTypeId.User
    private readonly pv = global.permissionValidator
    private readonly recipients: string[];

    constructor(params: {data: IMessage}) {
        this.data = params.data
        this.typeChecker = new nsMessages.TypeChecker(this.data.messagetype);
        this.isType = this.typeChecker.isType.bind(this.typeChecker)
        this.recipients = nsMessages.splitRecipients(params.data.addrecipient)
    }
}